module.exports = __webpack_public_path__ + "static/media/cq_editor_intestazione5.22875700.svg";